import { BasicHeaderNav } from '@components/Layouts/BasicHeaderNav';
import { ContentWrapperCustomerApp } from '@components/Layouts/ContentWrapperCustomerApp';
import { Trans } from '@lingui/react/macro';
import { NoddiButton } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';
import { useAuthContext } from 'noddi-web';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUserGroupSelection } from '../../hooks/useUserGroupSelection';

export const CompanySignupSuccess = () => {
  const { userData } = useAuthContext();
  const { selectUserGroup } = useUserGroupSelection();
  const navigate = useNavigate();
  const location = useLocation();
  const userGroupId = (location.state as { userGroupId?: number } | null)?.userGroupId;

  function onNavigateToHomepage() {
    if (userData?.user) {
      const organizationToSelect = userData.user.userGroups.find((ug) => ug.id === userGroupId);
      if (organizationToSelect) {
        selectUserGroup(organizationToSelect.id);
      }
    }

    navigate(customerRoutes.homepage.getPath());
  }

  return (
    <div className='min-h-screen bg-primary-background-gradient'>
      <BasicHeaderNav />
      <ContentWrapperCustomerApp>
        <div>
          <p className='mt-20 text-4xl font-bold text-primary'>
            <Trans>Thank you!</Trans>
          </p>
          <p className='mt-7 text-3xl font-bold text-noddiPurple'>
            {/* eslint-disable-next-line noddi/no-emoji-in-ui -- deliberate emoji in customer-facing copy: it carries the tone of the message, it is not a status a NoddiIcon could show */}
            <Trans>We will be in touch with you shortly</Trans>🚀
          </p>
          <p className='mt-4'>
            <Trans>If you have any questions, contact us at bedrift@noddi.no</Trans>
          </p>
          <p className='mt-2'>
            <Trans>If you want to create a booking right away, you can easily do that through your homepage</Trans>{' '}
          </p>
          <NoddiButton className='mt-4 self-end' onClick={onNavigateToHomepage}>
            <Trans>Go to homepage</Trans>
          </NoddiButton>
        </div>
      </ContentWrapperCustomerApp>
    </div>
  );
};
